import type { Money } from '@betterment/core';

export const LegacyTransferTypeEnum = {
  Deposit: 'DEPOSIT',
  Withdrawal: 'WITHDRAWAL',
  Transfer: 'TRANSFER',
};

export type LegacyTransferType = (typeof LegacyTransferTypeEnum)[keyof typeof LegacyTransferTypeEnum];

export type RecurringTransactionSource =
  | {
      __typename: 'BankAccount';
      id: string;
    }
  | {
      __typename: 'CashAccount';
      legacySubAccountId: number;
      id: string;
    }
  | {
      __typename: 'CheckingAccount';
      id: string;
    }
  | {
      __typename: 'CheckingExternalAccount';
      id: string;
    }
  | {
      __typename: 'DirectTradingAccount';
      id: string;
    }
  | {
      __typename: 'Five29Account';
      id: string;
    }
  | {
      __typename: 'ManagedSubAccount';
      legacySubAccountId: number;
      id: string;
    }
  | {
      __typename: 'TheirLegalSubAccount';
      id: string;
    };

export type RecurringTransactionFrequency =
  | {
      __typename: 'RecurringTransactionFrequencyAnnually';
      day: number;
      month: number;
    }
  | {
      __typename: 'RecurringTransactionFrequencyEveryOtherWeek';
      day: number;
    }
  | {
      __typename: 'RecurringTransactionFrequencyMonthly';
      day: number;
    }
  | {
      __typename: 'RecurringTransactionFrequencyTwiceAMonth';
      firstDay: number;
      secondDay: number;
    }
  | {
      __typename: 'RecurringTransactionFrequencyWeekly';
      day: number;
    };

export type RecurringTransactionConfig = {
  __typename: 'RecurringTransactionConfig';
  id: string;
  amount: Money;
  destinationName: string;
  isEditable: boolean;
  legacyId?: number | null;
  legacyTransferType: LegacyTransferType;
  legacyUuid?: string | null;
  sourceName: string;
  source: RecurringTransactionSource;
  frequency: RecurringTransactionFrequency;
};
